export const getBackendUrl = () => {
  const configured = (process.env.REACT_APP_BACKEND_URL || "").trim();

  if (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_DIRECT_API !== "true") {
    return "";
  }

  return configured;
};
